// todo: extract api calls from proposals.jsx and export them in here
import axios from "axios";
import proposalToolApi from "../../PropView/api/proposal-tool-api";
const apiUrl = proposalToolApi.getUrl();

const getProposals = async (projectId) => {
  console.log("apiUrl :>> ", apiUrl);
  const res = await axios.post(apiUrl, {
    method: "get_proposal_by_project_id",
    project_id: projectId,
  });
  return res;
};

const getCustomerInfo = async (projectId) => {
  const res = await axios.post(apiUrl, {
    method: "get_info",
    project_id: projectId,
  });
  return res;
};

const addSrec = async (product, amount, customer) => {
  const res = await axios.post(apiUrl, {
    method: "add_rsec",
    finanace_id: customer.financeId,
    SREC_Product__c: product,
    SREC_Company__c: "CSG",
    SREC_Amount__c: amount,
  });
  return res;
};

/**
 *
 * @param {string} oppId Came from customer.oppId originally in Proposals.jsx
 * @param {number} propName Came from propV originally in Proposals.jsx
 * @param {number} modCount Came from proposal.modCount originally in Proposals.jsx
 * @param {function} getCustomer Came from props.getCustomer originally in Proposals.jsx
 */
const createQuote = async (oppId, propName, modCount, getCustomer) => {
  const res = await axios.post(apiUrl, {
    method: "create_quote",
    OpportunityId: oppId,
    Name: `Proposal ${propName}`,
    Description: "TESTY MCTESTERSON",
    PricebookEntryId: "01u4T000000kudOQAQ",
    Quantity: modCount,
    UnitPrice: 22,
    Product2Id: "01to0000007TYxIAAW",
  });
  console.log(res);
  getCustomer();
};

export { getProposals, getCustomerInfo, addSrec, createQuote };
